module.exports = __webpack_public_path__ + "img/MANDIRI.d209abc1.svg";